document.addEventListener("DOMContentLoaded", () => {
  const fNavs = document.querySelectorAll(".mega-menu__content-link");
  const menuContents = document.querySelectorAll("[js-mega-menu-content]");
  const hasClass = "mega-menu__content-link__has-child";
  const menuItems = document.querySelectorAll(
    ".custom-header__menulist .menu-list .mega-menu .header__menu-item"
  );

  const menuContent1 = document.querySelectorAll(".mega-menu__content--1");
  const menuContent2 = document.querySelectorAll(".mega-menu__content--2");
  const closedNavs = document.querySelectorAll("[js-navigation-closed]");

  const destinationEls = document.querySelectorAll(
    ".mega-menu__content--1__search"
  );
  const searchInputs = document.querySelectorAll("[js-destination-input]");
  const searchBtns = document.querySelectorAll("[js-destination-searchbtn]");

  //init
  menuItems.forEach((menu) => {
    menu.addEventListener("mouseover", () => {
      fNavs.forEach((nav) => {
        nav.classList.remove("active");
      });

      menuContent1.forEach((content) => {
        content.classList.remove("open");
      });

      menuContent2.forEach((content) => {
        content.classList.remove("open");
      });
    });
  });

  fNavs.forEach((nav) => {
    nav.addEventListener("click", (e) => {
      const linkHandle = nav.getAttribute("data-link-handle");
      const contentIdx = nav.getAttribute("data-index");

      // Leaf links navigate normally; only intercept parents with children
      if (!nav.classList.contains(hasClass)) {
        return;
      }

      e.preventDefault();

      fNavs.forEach((rmNav) => {
        rmNav.classList.remove("active");
      });

      nav.classList.add("active");

      menuContent2.forEach((content) => {
        content.classList.remove("open");
      });

      menuContents.forEach((content) => {
        const menuIdx = content.getAttribute("data-index");
        if (menuIdx === contentIdx) {
          content.classList.add("open");

          const childContents = content.querySelectorAll(
            ".mega-menu__content-child"
          );
          childContents.forEach((childContent) => {
            if (childContent.getAttribute("data-link-handle") === linkHandle) {
              const timer = setTimeout(() => {
                childContent.classList.remove("hide");
                childContent.classList.remove("fade-out");
              }, 150);
              childContent.classList.remove("transition");
            } else {
              childContent.classList.add("fade-out");
              childContent.classList.add("transition");
              const timer = setTimeout(() => {
                childContent.classList.add("hide");
              }, 150);
            }
          });
        }
      });

      destinationEls.forEach((element) => {
        if (
          element &&
          linkHandle === element.getAttribute("data-link-handle")
        ) {
          const timer = setTimeout(() => {
            element.classList.remove("hide");
            element.classList.remove("fade-out");
          }, 150);
          element.classList.remove("transition");
        } else {
          element.classList.add("fade-out");
          element.classList.add("transition");
          const timer = setTimeout(() => {
            element.classList.add("hide");
          }, 150);
        }
      });

      initSearch();
    });
  });

  // menu events | uncomment if you want to enable 3rd drawer
  // const sMenuItems = document.querySelectorAll('[js-second-menu-item]');
  // sMenuItems.forEach(item => {
  //   item.addEventListener('click', (e) => {
  //     e.preventDefault();
  //     const itemHandle = item.getAttribute('data-link-handle');

  //     if (itemHandle === 'view-all') {
  //       window.location.href = item.href;
  //       return
  //     }

  //     const handle = item.getAttribute('data-collection-id');
  //     fetch(`/collections/${handle}/products.json?limit=5`)
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log(data.products); // array of product objects
  //       const products = data.products;
  //       if (products.length > 0) {
  //         const collection_title = item.getAttribute('data-link-title');

  //         let productHtml = `<div class="product-list"><div class="product-list__slick" id="nav-slick">`;
  //         products.forEach((product, index) => {
  //           const image = product.images[0].src;
  //           const title = product.title;

  //           const aspect_val = product.images[0].width / product.images[0].height;

  //           productHtml += `
  //             <div class="product-item" data-title="${title}">
  //               <a href="/products/${product.handle}">
  //                 <img src="${image}" alt="${title}" style="aspect-ratio: ${aspect_val}; --width: ${aspect_val > 1 ? '70%': '55%'};"/>
  //               </a>
  //             </div>
  //           `;
  //         });
  //         productHtml += `
  //           </div>
  //           <div class="product-list__bottom">
  //             <p class="product-list__bottom-title">${products[0].title}</p>
  //             <p>${collection_title}</p>

  //             <a href="/collections/${handle}" class="product-list__bottom-link">
  //               View Full Collection
  //             </a>
  //           </div>
  //         `;
  //         productHtml += '</div>';

  //         const menuContent = item.closest('[js-mega-menu-content]').parentNode.querySelector('.mega-menu__content--2');
  //         if (menuContent.getAttribute('data-index') == '2') {
  //           menuContent.classList.add('open');

  //           menuContent.innerHTML = productHtml;
  //           setTimeout(() => {
  //             initSlick();
  //           }, 450);
  //         }
  //       } else {
  //         window.location.href = item.href;
  //       }
  //     });
  //   })
  // });

  // Search inputs
  searchBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const input = btn.parentNode.querySelector("input");
      eventSearch(input);
    });
  });

  searchInputs.forEach((input) => {
    input.addEventListener("input", (e) => {
      eventSearch(input);
    });
  });

  function initSearch() {
    const cContents = document.querySelectorAll(".mega-menu__content-child");
    cContents.forEach((content) => {
      if (content.getAttribute("data-link-handle") === "by-destination") {
        content.querySelectorAll("li").forEach((el) => {
          el.classList.remove("hide");
        });
      }
    });

    searchInputs.forEach((input) => {
      input.value = "";
    });
  }

  function eventSearch(input) {
    const childContents = document.querySelectorAll(
      ".mega-menu__content-child"
    );
    const inputVal = input ? input.value.toLowerCase().trim() : "";
    if (inputVal != "") {
      childContents.forEach((content) => {
        if (content.getAttribute("data-link-handle") === "by-destination") {
          content.querySelectorAll("li").forEach((el) => {
            if (
              !el.classList.contains("mega-menu__content-grandchild__header")
            ) {
              const text = el
                .querySelector("a")
                .getAttribute("data-link-title")
                .toLowerCase()
                .trim();
              if (!text.includes(inputVal)) {
                el.classList.add("hide");
              } else {
                el.classList.remove("hide");
              }
            }
          });

          document
            .querySelectorAll(".mega-menu__content-grandchild__header")
            .forEach((header) => {
              const regionTitle = header.getAttribute("data-region-title");
              let isExist = false;
              if (
                header.parentNode.getAttribute("data-link-handle") !==
                "by-destination"
              )
                return;
              content.querySelectorAll("li").forEach((el) => {
                if (
                  el.getAttribute("data-region-title") === regionTitle &&
                  !el.classList.contains("hide") &&
                  el != header
                ) {
                  isExist = true;
                }
              });

              if (isExist) {
                header.classList.remove("hide");
              } else {
                header.classList.add("hide");
              }
            });
        }
      });
    } else {
      childContents.forEach((content) => {
        if (content.getAttribute("data-link-handle") === "by-destination") {
          content.querySelectorAll("li").forEach((el) => {
            el.classList.remove("hide");
          });
        }
      });

      document
        .querySelectorAll(".mega-menu__content-grandchild__header")
        .forEach((header) => {
          header.classList.remove("hide");
        });
    }
  }

  // mobile menu

  const childItems = document.querySelectorAll("[js-childlink-title] ");
  const lastContents = document.querySelectorAll(
    "[js-mobile-menu-last-content]"
  );
  const subMenus = document.querySelectorAll("[js-mobile-submenu]");
  const backBtns = document.querySelectorAll("[js-mobile-menu-last-back]");

  childItems.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      subMenus.forEach((menu) => {
        menu.classList.add("remove");
      });

      const handle = btn.getAttribute("data-handle");
      lastContents.forEach((content) => {
        const lastHandle = content.getAttribute("data-handle");
        if (lastHandle === handle) {
          content.classList.remove("hide");
          content.parentNode.classList.add("active");
        } else {
          content.classList.add("hide");
        }
      });

      initSearch();
    });
  });

  backBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      if (
        btn
          .closest(".menu-drawer__inner-submenu--last")
          .classList.contains("active")
      ) {
        btn
          .closest(".menu-drawer__inner-submenu--last")
          .classList.remove("active");
      }

      subMenus.forEach((menu) => {
        if (menu.classList.contains("remove")) {
          menu.classList.remove("remove");
        }
      });
    });
  });

  // desktop menu
  const dMenus = document.querySelectorAll(".mega-menu");
  closedNavs.forEach((closedNav) => {
    closedNav.addEventListener("click", () => {
      closedNav.classList.remove("active");
      initMenus();

      // document.querySelectorAll('[js-mega-menu-content]').forEach(element => {
      //   element.classList.remove('open');
      // });

      // dMenus.forEach(menu => {
      //   menu.removeAttribute('open');
      // });
    });
  });

  dMenus.forEach((menu) => {
    const summary = menu.querySelector(".header__menu-item");
    if (summary) {
      summary.addEventListener("click", (e) => {
        e.preventDefault();
        // get the menu list and add open class
        document
          .querySelectorAll(".custom-header__menulist .menu-list")
          .forEach((menuList) => {
            menuList
              .querySelectorAll(".mega-menu__content .mega-menu__content--0")
              .forEach((content) => {
                if (!content.classList.contains("open")) {
                  content.classList.add("open");
                }
              });
          });

        if (summary.classList.contains("active")) {
          const link = summary.querySelector("a");
          if (link && link.getAttribute("href") && link.getAttribute("href") !== "#") {
            window.location.href = link.href;
          }
          return;
        }

        // Check if another menu is currently open
        const currentlyOpenMenu = document.querySelector(".mega-menu[open]");
        const isSwitchingMenus =
          currentlyOpenMenu && currentlyOpenMenu !== menu;

        if (isSwitchingMenus) {
          // Keep drawer open, just fade content
          const currentContent = currentlyOpenMenu.querySelector(".mega-menu__content--0.open");
          
          // Remove active state from other menu items
          document
            .querySelectorAll(".mega-menu .header__menu-item")
            .forEach((item) => {
              item.classList.remove("active");
            });

          // Fade out current content
          if (currentContent) {
            currentContent.classList.add("fade-out");
          }

          // Close the currently open menu
          currentlyOpenMenu.removeAttribute("open");

          // Small delay for fade effect, then open new menu
          setTimeout(() => {
            if (currentContent) {
              currentContent.classList.remove("fade-out");
            }
            openNewMenu(menu, summary);
          }, 150);
        } else {
          // No menu is currently open, open directly
          openNewMenu(menu, summary);
        }
      });
    }
  });
});

// Helper function to open a new menu
function openNewMenu(menu, summary) {
  summary.classList.add("active");
  menu.setAttribute("open", true);

  const content = summary.nextElementSibling;
  if (content) {
    const elements = content.querySelectorAll("[js-mega-menu-content]");
    if (elements.length > 0) elements[0].classList.add("open");
  }

  document.querySelector("[js-navigation-closed]").classList.add("active");
}

function initMenus() {
  const dMenus = document.querySelectorAll(".mega-menu");
  const bgOverlay = document.querySelector(".mega-menu__content__bg");

  dMenus.forEach((menu) => {
    const summary = menu.querySelector(".header__menu-item");
    summary.classList.remove("active");

    // Close menu instantly without transition
    if (menu.hasAttribute("open")) {
      menu.removeAttribute("open");

      // Add closing state to background overlay for instant close
      if (bgOverlay) {
        bgOverlay.classList.add("closing");
        setTimeout(() => {
          bgOverlay.classList.remove("closing");
        }, 10);
      }
    }

    const content = summary.nextElementSibling;
    if (content) {
      const elements = content.querySelectorAll("[js-mega-menu-content]");
      elements.forEach((element) => {
        element.classList.remove("open");
      });
    }

    document.querySelector("[js-navigation-closed]").classList.remove("active");
  });
}

function initSlick() {
  $("#nav-slick").slick({
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0px",
    slidesToScroll: 1,
    prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">
      <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.08333 12.875L0.75 6.875L6.08333 0.875" stroke="#3E4856" stroke-linecap="round"/>
      </svg>
    </button>`,
    nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.41667 0.875L6.75 6.875L1.41667 12.875" stroke="#3E4856" stroke-linecap="round"/>
      </svg>
    </button>`,
  });

  $("#nav-slick").on("afterChange", function (event, slick, currentSlide) {
    const productItems = document.querySelectorAll(
      ".product-list__slick .product-item"
    );
    const productTitle = document.querySelector(".product-list__bottom-title");

    productItems.forEach((item, index) => {
      if (index === currentSlide) {
        const title = item.getAttribute("data-title");

        if (productTitle) {
          productTitle.innerHTML = title;
        }
      }
    });
  });
}
